import { IAppAction, ActionType } from "../actions/Helpers";
import { IBulkOpsState, IBulkIdsMap, IBulkFailedEvents } from "@vmosolutions/oc-interfaces";

export interface IBulkReduxState {
  [key: string]: IBulkOpsState;
}

const defaultState: IBulkReduxState = {};

export const BulkOpsReducer = (state = defaultState, action: IAppAction): IBulkReduxState => {
  switch (action.type) {
    case ActionType.CREATE_BULK_BATCH: {
      const currentOp = state[action.payload.batchId];

      // When running chunked calls, they will register as new even though info might already exist in redux.

      if (currentOp) {
        // MODIFY EXISTING
        const { chunkId, records } = action.payload.bulkOpsState;
        const chunkIds = state[action.payload.batchId].chunkIds;
        const newChunkCall = !chunkIds.includes(chunkId);

        // If a new update call comes in and contains a chunk id that hasn't been registered,
        // Increment record count and add it to array (so we don't count it a second time).
        const updatedRecords = newChunkCall
          ? state[action.payload.batchId].records + records
          : state[action.payload.batchId].records;
        const updatedChunkIds = newChunkCall
          ? [...state[action.payload.batchId].chunkIds, chunkId]
          : state[action.payload.batchId].chunkIds;

        const updatedState = {
          ...state,
          [action.payload.batchId]: {
            ...state[action.payload.batchId],
            records: updatedRecords,
            chunkId,
            chunkIds: updatedChunkIds,
          },
        };

        return updatedState;
      } else {
        const chunkId = action?.payload?.bulkOpsState?.chunkId;
        // CREATE NEW
        const newBulkOp: IBulkOpsState = {
          sub: action.payload.sub,
          actionType: action?.payload?.actionType ?? action?.payload?.bulkOpsState?.actionType,
          records: action.payload.bulkOpsState.records,
          successfulEventIds: [],
          failedEvents: [],
          chunkId,
          chunkIds: chunkId ? [chunkId] : [],
        };
        return { ...state, [action.payload.batchId]: newBulkOp };
      }
    }

    case ActionType.UPDATE_BULK_BATCH: {
      if (!state[action.payload.batchId]) {
        return state;
      }

      const successfulEventIds = action.payload.bulkOpsState.successfulEventIds
        ? state[action.payload.batchId].successfulEventIds?.length > 0
          ? updateSuccesfulEvents(
              state[action.payload.batchId].successfulEventIds,
              action.payload.bulkOpsState.successfulEventIds
            )
          : action.payload.bulkOpsState.successfulEventIds
        : state[action.payload.batchId].successfulEventIds;

      const failedEvents = action.payload?.bulkOpsState?.failedEvents
        ? state[action.payload?.batchId].failedEvents?.length > 0
          ? updateFailedEvents(state[action.payload.batchId].failedEvents, action.payload.bulkOpsState.failedEvents)
          : action.payload.bulkOpsState.failedEvents
        : state[action.payload.batchId].failedEvents;

      return {
        ...state,
        [action.payload.batchId]: {
          ...state[action.payload.batchId],
          actionType: action?.payload?.actionType ?? action?.payload?.bulkOpsState?.actionType,
          successfulEventIds,
          failedEvents,
        },
      };
    }

    default:
      return state;
  }
};

//update the events in the batch
const updateSuccesfulEvents = (state: IBulkIdsMap[], updates: IBulkIdsMap[]): IBulkIdsMap[] => {
  updates.forEach((update: IBulkIdsMap) => {
    state.push(update);
  });
  return state;
};

//update failed events in the batch
const updateFailedEvents = (state: IBulkFailedEvents[], updates: IBulkFailedEvents[]): IBulkFailedEvents[] => {
  updates.forEach((update: IBulkFailedEvents) => {
    state.push(update);
  });
  return state;
};
